/** @format */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "icons";

const FollowedInfoCard = (props) => {
    const { type, handleDismiss, subTopic } = props;

    const onClose = () => {
        handleDismiss(null);
    };

    const getCssClass = () => {
        switch (type) {
            case "followed":
            case "bookmarked":
            case "subscribed":
                return "followed";
            case "unfollowed":
            case "unbookmarked":
            case "unsubscribed":
                return "unfollowed";
            case "error":
                return "error";
            case "logged-in":
                return "logged-in";
            case "email-verified":
                return "email-verified";
            default:
                return "";
        }
    };

    // const singularize = (plural) => {

    //     let pluralValue = plural.toLowerCase();

    //     if (subTopic.toLowerCase() === "new applications") {
    //         pluralValue = "significant development applications";
    //     }

    //     switch (pluralValue) {
    //         case 'stories':
    //             return 'story';
    //         case 'Council documents':
    //             return 'new ';
    //         case 'significant development applications': // special case; not pluralized
    //             return 'development applications';
    //         default:
    //             return plural;
    //     }
    // };

    const getManageSubscriptionsLink = () => `${window.location.origin}/mydnv`;

    const getManageFollowLink = () => `${window.location.origin}/mydnv?t=pages+i%27m+watching`;

    const getManageBookmarksLink = () => `${window.location.origin}/mydnv?t=my%20bookmarks`;

    const getManagePreferencesLink = () => `${window.location.origin}/mydnv?t=my%20account`;

    return (
        <div className={"follow-box " + getCssClass()}>
            <div className="iconBox">
                {<FontAwesomeIcon icon={solid.faCircleCheck} />}
                {<FontAwesomeIcon icon={solid.faCircleExclamation} />}
                {type === "error" && <FontAwesomeIcon icon={solid.faCircleXmark} />}
            </div>

            <div className="msgBox">
                {type === "followed" && <h4>Watching this page</h4>}
                {type === "unfollowed" && <h4>Stopped watching this page</h4>}
                {type === "subscribed" && <h4>Subscribed</h4>}
                {type === "unsubscribed" && <h4>Unsubscribed</h4>}
                {type === "bookmarked" && <h4>Page bookmarked</h4>}
                {type === "unbookmarked" && <h4>Bookmark removed</h4>}
                {type === "logged-in" && <h4>You are now logged in to your MyDNV account</h4>}
                {type === "email-verified" && <h4>Your email is verified. You can now close this page.</h4>}
                {type === "error" && <h4>Sorry, an error has occurred</h4>}

                {type === "followed" && (
                    <p className="follow-msg">We&apos;ll notify you by email when we add new information.</p>
                )}

                {type === "unfollowed" && (
                    <p className="follow-msg">You&apos;ll no longer receive notifications about future updates.</p>
                )}

                {/* {type === 'subscribed' && (subTopic === 'Stories' || subTopic === 'Council documents') && (
                    <p className='follow-msg'>We&apos;ll notify you by email when we publish new {subTopic}.</p>
                )}

                {type === 'unsubscribed' && (
                    <p className='follow-msg'>You&apos;ve unsubscribed from {singularize(subTopic)} notifications.</p>
                )} */}

                {type === "subscribed" && subTopic === "News" && (
                    <p className="follow-msg">We&apos;ll notify you by email when we publish news updates.</p>
                )}

                {type === "unsubscribed" && subTopic === "News" && (
                    <p className="follow-msg">You&apos;ve unsubscribed from news update notifications.</p>
                )}

                {type === "subscribed" && subTopic === "Advisories" && (
                    <p className="follow-msg">We&apos;ll notify you by email when we publish a new advisory.</p>
                )}

                {type === "unsubscribed" && subTopic === "Advisories" && (
                    <p className="follow-msg">You&apos;ve unsubscribed from new advisory notifications.</p>
                )}

                {type === "subscribed" && subTopic === "Stories" && (
                    <p className="follow-msg">We&apos;ll notify you by email when we publish new stories.</p>
                )}

                {type === "unsubscribed" && subTopic === "Stories" && (
                    <p className="follow-msg">You&apos;ve unsubscribed from new story notifications.</p>
                )}

                {type === "subscribed" && subTopic === "Council Documents" && (
                    <p className="follow-msg">We&apos;ll notify you by email when we publish new Council documents.</p>
                )}

                {type === "unsubscribed" && subTopic === "Council Documents" && (
                    <p className="follow-msg">You&apos;ve unsubscribed from new Council document notifications.</p>
                )}

                {type === "subscribed" && subTopic === "Input opportunities" && (
                    <p className="follow-msg">
                        We&apos;ll notify you by email when we publish new input opportunities.
                    </p>
                )}

                {type === "unsubscribed" && subTopic === "Input opportunities" && (
                    <p className="follow-msg">You&apos;ve unsubscribed from new input opportunity notifications.</p>
                )}

                {type === "subscribed" && subTopic === "New applications" && (
                    <p className="follow-msg">
                        We&apos;ll notify you by email when we publish new significant development applications.
                    </p>
                )}

                {type === "unsubscribed" && subTopic === "New applications" && (
                    <p className="follow-msg">
                        You&apos;ve unsubscribed from new development applications notifications.
                    </p>
                )}

                {type === "error" && <p className="follow-msg">We were unable to process your request.</p>}

                {type && type.indexOf("follow") > -1 && (
                    <p>
                        <a href={getManageFollowLink()}>Manage pages I&apos;m watching</a>
                    </p>
                )}

                {type && type.indexOf("subscribe") > -1 && (
                    <p>
                        <a href={getManageSubscriptionsLink()}>Manage my subscriptions</a>
                    </p>
                )}

                {type === "unbookmarked" && (
                    <>
                        <p className="follow-msg">You have removed this page from your list of bookmarks.</p>
                        <p>
                            <a href={getManageBookmarksLink()}>Manage my bookmarks</a>
                        </p>
                    </>
                )}

                {type === "bookmarked" && (
                    <>
                        <p className="follow-msg">You have added this page to your list of bookmarks.</p>
                        <p>
                            <a href={getManageBookmarksLink()}>Manage my bookmarks</a>
                        </p>
                    </>
                )}

                {type && type.indexOf("logged-in") > -1 && (
                    <p>
                        <a href={getManagePreferencesLink()}>Manage your preferences</a>
                    </p>
                )}
            </div>

            {type !== "logged-in" &&  type !== "email-verified" &&(
                <div className="btn-close">
                    <button onClick={() => onClose()}>
                        <FontAwesomeIcon icon={solid.faXmark} />
                    </button>
                </div>
            )}
        </div>
    );
};

export { FollowedInfoCard };
